import React from 'react';
import { ArrowRightIcon, HelpCircleIcon } from 'lucide-react';
import { needToKnow, painQuestions, pathSteps } from '../data/content';
import { Eyebrow, Mark, SectionLead, SectionTitle } from './ui/Section';
export function Pain() {
  return <section className="border-y border-slate-200 bg-slate-50 px-4 py-12 md:py-16" data-id="element-312" data-mp="1izv5igoyqezq">
      <div className="mx-auto max-w-4xl" data-id="element-313" data-mp="1e1tpk4mu2vsh">
        <Eyebrow danger data-id="element-314" data-mp="1a11bmy30o2pv">😤 La realidad</Eyebrow>
        <SectionTitle data-id="element-315" data-mp="1a1t9kfk36cjb">
          ¿Querés hacer muebles para tu casa pero{' '}
          <span className="text-sky-600" data-id="element-316" data-mp="15a1fvw5mvqoy">no sabés por dónde empezar?</span>
        </SectionTitle>
        <SectionLead data-id="element-317" data-mp="10aor35v7c9jq">
          Ves una mesa, un organizador, una biblioteca o una repisa que te gustaría tener. Pensás:
        </SectionLead>
        <p className="mt-4 text-center text-2xl font-black italic text-slate-900 md:text-4xl" data-id="element-318" data-mp="vdyg2wy98456">
          “Esto podría hacerlo yo.”
        </p>
        <SectionLead data-id="element-319" data-mp="mbp7wdqgkmuy">
          Pero cuando llega el momento de empezar aparecen todas las preguntas.
        </SectionLead>

        <ul className="mt-8 grid gap-2.5 sm:grid-cols-2" data-id="element-320" data-mp="1yw89zh3ngiwn">
          {painQuestions.map(question => <li key={question} className="flex items-start gap-3 rounded-xl border border-slate-200 bg-white p-3.5" data-id="element-321" data-mp="23ornke2c7e1g">
              <HelpCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" data-id="element-322" data-mp="1txx0j7h9oaey" />
              <span className="text-sm font-semibold text-slate-700 md:text-base" data-id="element-323" data-mp="1tvtzlsekswvg">{question}</span>
            </li>)}
        </ul>

        <div className="mx-auto mt-8 max-w-2xl space-y-3 text-center text-sm font-semibold leading-relaxed text-slate-600 md:text-base" data-id="element-324" data-mp="2mn3xi212ory3">
          <p data-id="element-325" data-mp="28mt6myzrjdcx">
            Entonces empezás a mirar videos, guardar fotos, comparar medidas diferentes... y el
            proyecto termina quedando para más adelante.
          </p>
          <p data-id="element-326" data-mp="x74k28qf8gcn">
            O terminás comprando un mueble terminado cuando podrías haber construido una solución
            práctica para tu propia casa.
          </p>
        </div>

        <div className="mt-10 rounded-2xl border-2 border-dashed border-sky-600 bg-white p-6 text-center md:p-10" data-id="element-327" data-mp="33wfz3t8vm0kf">
          <p className="text-lg font-black uppercase leading-tight text-slate-900 md:text-2xl" data-id="element-328" data-mp="2yyee32rw3r6b">
            No necesitás juntar más ideas sueltas.
          </p>
          <p className="mt-2 text-sm font-semibold text-slate-600 md:text-base" data-id="element-329" data-mp="2p7jq9tyzwjir">Necesitás saber:</p>
          <ul className="mt-5 space-y-1.5" data-id="element-330" data-mp="2l5f41gavmp65">
            {needToKnow.map(item => <li key={item} className="text-2xl font-black uppercase leading-tight text-sky-600 md:text-4xl" data-id="element-331" data-mp="2g6lo7h84am2t">
                {item}
              </li>)}
          </ul>
          <p className="mt-6 text-base font-bold text-slate-700 md:text-lg" data-id="element-332" data-mp="2697jufzgxnqv">
            <Mark data-id="element-333" data-mp="9fvyecyu9h6t">Muebles Fáciles en Casa</Mark> te da ese camino.
          </p>
          <ol className="mt-5 flex flex-col items-center justify-center gap-2 text-sm font-bold text-slate-700 md:flex-row md:flex-wrap md:text-base" data-id="element-334" data-mp="9drwu1oewu9p">
            {pathSteps.map((step, index) => <li key={step} className="flex items-center gap-2" data-id="element-335" data-mp="cw8tussr27y9" data-mpi={index}>
                {index > 0 && <ArrowRightIcon className="hidden h-4 w-4 text-sky-600 md:block" aria-hidden="true" data-id="element-336" data-mp="gxalangfdfpo" />}
                <span className="rounded-lg bg-sky-50 px-3 py-1.5" data-id="element-337" data-mp="qp6sqp4eii6k">{step}</span>
              </li>)}
          </ol>
          <p className="mt-5 text-sm font-semibold text-slate-600 md:text-base" data-id="element-338" data-mp="3q5n06ceit73f">
            Y avanzás paso a paso hasta tenerlo terminado.
          </p>
        </div>
      </div>
    </section>;
}